export default __webpack_public_path__ + "static/media/2_atitude.05a595d1.svg";